import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "tags", "error"]

  connect() {
    this.tagIndex = 0 // used for new nested fields
  }

  // Called when keypress on input
  inputTargetKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.addEmail()
    }
  }

  // Called when clicking the Add button or pressing Enter
  addEmail() {
    const email = this.inputTarget.value.trim()
    if (email === "") return

    if (!this.isValidEmail(email)) {
      this.showError("Endereço de email inválido")
      return
    }

    if (this.emailExists(email)) {
      this.showError("O email já existe na lista")
      return
    }

    this.addTag(email)
    this.inputTarget.value = ""
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
    this.inputTarget.classList.add("ring-2", "ring-red-500", "ring-inset")

    // Hide after 3 seconds
    clearTimeout(this.errorTimeout)
    this.errorTimeout = setTimeout(() => {
      this.hideError()
    }, 1500)
  }

  clearError() {
    this.hideError()
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.classList.add("hidden")
    this.inputTarget.classList.remove("ring-2", "ring-red-500", "ring-inset")
  }

  remove(event) {
    const tag = event.target.closest('[data-cc-emails-target="tag"]')
    if (!tag) return

    // If there is a _destroy hidden field inside, set to true
    const destroyField = tag.querySelector('[data-destroy-field]')
    if (destroyField) {
      destroyField.value = "1"
      tag.style.display = "none"
    } else {
      // For new records, just remove the element
      tag.remove()
    }
  }

  addTag(email) {
    const tag = document.createElement("div")
    tag.className = "flex items-center gap-1 bg-indigo-100 text-indigo-800 px-2 py-1 rounded"
    tag.setAttribute("data-cc-emails-target", "tag")

    const span = document.createElement("span")
    span.textContent = email
    tag.appendChild(span)

    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "text-indigo-600 hover:text-indigo-900"
    btn.textContent = "×"
    btn.setAttribute("data-action", "cc-emails#remove")
    tag.appendChild(btn)

    // Hidden input for new nested attribute
    const hiddenEmail = document.createElement("input")
    hiddenEmail.type = "hidden"
    hiddenEmail.name = `supplier[cc_emails_attributes][${this.tagIndex}][email]`
    hiddenEmail.value = email
    tag.appendChild(hiddenEmail)

    const hiddenDestroy = document.createElement("input")
    hiddenDestroy.type = "hidden"
    hiddenDestroy.name = `supplier[cc_emails_attributes][${this.tagIndex}][_destroy]`
    hiddenDestroy.value = "0"
    hiddenDestroy.setAttribute("data-destroy-field", "true")
    tag.appendChild(hiddenDestroy)

    this.tagsTarget.appendChild(tag)
    this.tagIndex += 1
  }

  isValidEmail(email) {
    // Simple regex; ideally use more robust, but fine
    return /\S+@\S+\.\S+/.test(email)
  }

  emailExists(email) {
    return Array.from(this.tagsTarget.querySelectorAll("span")).some(el => el.textContent === email)
  }
} 
